import {useMediaQuery} from "@mui/material";

export const useIsTouch = () => {
  return useMediaQuery("(pointer: coarse)");
};

export const useIsMouse = () => {
  return useMediaQuery("(pointer: fine)");
};
